/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type subsidy_SubsidyOfficeResponse = {
    address_line_1?: string;
    address_line_2?: string;
    calculation_method?: subsidy_SubsidyOfficeResponse.calculation_method;
    city?: string;
    country?: string;
    created_at?: string;
    deleted_at?: string;
    iban?: string;
    id?: string;
    name?: string;
    notes?: string;
    org_id?: string;
    postal_code?: string;
    qr_iban?: string;
    updated_at?: string;
};
export namespace subsidy_SubsidyOfficeResponse {
    export enum calculation_method {
        ZURICH_BF = 'zurich_bf',
        FLAT = 'flat',
    }
}

